import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {RootNavigatorParams} from 'navigation/Routes';
import {ComingSoon} from 'components/common/comingSoon';
export function EpicManager({
  navigation,
}: NativeStackScreenProps<RootNavigatorParams>) {
  return (
    <ComingSoon
      text=" Plan and manage large objectives by breaking them into smaller, manageable tasks for better execution."
      imageSource={require('assets/illustrations/coming-soon-epics.png')}
    />
  );
}
